// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__yebuX","block__top":"style_block__top__KAeXZ","block__bottom":"style_block__bottom__twxaO","parserChart":"style_parserChart__0m2AF"};